<ds-tabs-group
    msThemedTabs
    size="small"
    variant="horizontal"
    [themedInverse]="themeInverseIndicator"
    [scrollable]="scrollEnabled"
    [fullWidthTabs]="false">
    @for (tab of events; track tab.event.id) {
        <ds-tab [name]="$index.toString()">
            <ng-container *dsTabHeader>
                <a (click)="selected($event, tab, $index)">
                    <ms-showcase-scoreboard [event]="tab.event" />
                </a>
            </ng-container>
        </ds-tab>
    }
</ds-tabs-group>
